let HttpInterceptor = ($localStorage, $sessionStorage) => {
    var interceptor = {
      request: function(config) {
        var token = $localStorage.token || $sessionStorage.token;

        if(token) {
          config.headers = config.headers || {};
          config.headers.Authorization = 'Bearer ' + token;
        }
        config.timeout = 1000 * 60 * 30

        return config;
      }
    };

    return interceptor;
};

HttpInterceptor.$inject = ['$localStorage', '$sessionStorage'];

export default HttpInterceptor;



// WEBPACK FOOTER //
// ./client/app/common/services/http-interceptor.js